// import { classNames } from 'shared/lib/classNames/classNames'
import { Link, useLocation } from 'react-router-dom'
import cls from './Header.module.scss'
import { memo, useEffect, useState } from 'react'
import { ItemHeader } from './ItemHeader'

interface HeaderProps {
    className?: string
}

export const Header = memo((props: HeaderProps) => {
    const { className } = props
    const [arrow, setArrow] = useState(false)

    const location = useLocation()

    useEffect(() => {
        if (location.pathname !== '/') {
            setArrow(true)
        } else {
            setArrow(false)
        }
    }, [location.pathname])

    return (
        <header className={cls.header}>
            <div className={cls.headerTitle}>SMIRNOV MATVEY - FRONTEND DEV.</div>
            <div className={cls.container}>
                <ItemHeader to='/about' name='Обо мне' />
                <div className={cls.divider}>/</div>
                <ItemHeader to='/works' name='Проекты' />
                <div className={cls.divider}>/</div>
                <ItemHeader to='/links' name='Связь и ссылки' />
                {arrow ? <>
                    <div className={cls.divider}>/</div>
                    <ItemHeader to='/' name='На главную' />
                </> : null}
            </div>
        </header>
    )
})
